import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import {
  CardSubElements,
  Classes,
  CustomElement,
  Layout,
  LinkParameters,
  Colors,
  GeneralCardSubElements,
} from "@/types";
import {
  canVModel,
  castLayoutRow,
  getBreakpoint,
  getBreakpointClasses,
  getCssColor,
  getIonicColor,
  getLayout,
  getSize,
  isMatrix,
} from "@/utils";
import { isRequest, isEvent } from "@/utils";
import {
  IonCard,
  IonCardHeader,
  IonCardTitle,
  IonCardSubtitle,
  IonCardContent,
  IonGrid,
  IonRow,
  IonCol,
  IonLabel,
} from "@ionic/vue";
import { nextTick, onBeforeUnmount, onMounted } from "vue";
import { PropType, ref, toRef, watch } from "vue";
import { useStore } from "vuex";

export default /*#__PURE__*/_defineComponent({
  __name: 'GeneralCard',
  props: {
  id: {
    type: [String, Number],
    required: true,
  },
  title: Object as PropType<CustomElement>,
  subtitle: Object as PropType<CustomElement>,
  content: Array<CustomElement>,
  layout: Object as PropType<Layout>,
  side_element: Object as PropType<CustomElement>,
  selected: Boolean,
  hovered: Boolean,
  link: Object as PropType<LinkParameters>,
  colors: Object as PropType<Colors<GeneralCardSubElements>>,
  classes: Object as PropType<Classes<CardSubElements>>,
},
  emits: [
  "execute_link",
  "signal_event",
  "update:title",
  "update:subtitle",
  "update:content",
  "update:side_element",
],
  setup(__props, { emit }) {

const props = __props;

_useCssVars(_ctx => ({
  "07dbef51": (_unref(css_background_color)),
  "90669dfe": (_unref(css_hover_color))
}))

IonLabel;

const updateBreakpoint = () => {
  breakpoint.value = getBreakpoint(window.innerWidth);
  actual_layout.value = getLayout(props.layout, breakpoint.value);
};

const store = useStore();

// <!-- TODO (4): forse manca propagazione del content tra gli stessi elementi (es. id:name e id:name_sm) e elementi collegati (id:number + id:group e id:number_group), visto che al momento, se si scrive una cosa su un elemento in un certo layout, quando si cambierà layout l'elemento collegato non avrà lo stesso valore


const isGet =
  props.link != undefined &&
  isRequest(props.link) &&
  props.link.method == "get";
const css_background_color =
  props.colors?.background != undefined
    ? getCssColor(props.colors.background)
    : undefined;
const css_hover_color =
  props.colors?.hover != undefined
    ? getCssColor(props.colors.hover)
    : undefined;

const local_hovered = toRef(props, "hovered");

const title_ref = ref(props.title);
const subtitle_ref = ref(props.subtitle);
const content_ref = ref(props.content);
const side_element_ref = ref(props.side_element);
const breakpoint = ref(getBreakpoint(window.innerWidth));
const actual_layout = ref(getLayout(props.layout, breakpoint.value));

if (props.title != undefined && canVModel(props.title)) {
  watch(
    () => props.title,
    (value) => {
      title_ref.value = value;
    }
  );
  watch(
    () => title_ref.value,
    (value) => {
      emit("update:title", value);
    }
  );
}
if (props.subtitle != undefined && canVModel(props.subtitle)) {
  watch(
    () => props.subtitle,
    (value) => {
      subtitle_ref.value = value;
    }
  );
  watch(
    () => subtitle_ref.value,
    (value) => {
      emit("update:subtitle", value);
    }
  );
}
if (
  props.content != undefined &&
  props.content.find((e) => canVModel(e)) != undefined
) {
  watch(
    () => props.content,
    (value) => {
      content_ref.value = value;
    }
  );
  watch(
    () => content_ref.value,
    (value) => {
      emit("update:content", value);
    }
  );
}
if (props.side_element != undefined && canVModel(props.side_element)) {
  watch(
    () => props.side_element,
    (value) => {
      side_element_ref.value = value;
    }
  );
  watch(
    () => side_element_ref.value,
    (value) => {
      emit("update:side_element", value);
    }
  );
}

if (Object.keys(props.classes ?? {}).length > 0) {
  onMounted(() =>
    nextTick(() => {
      window.addEventListener("resize", updateBreakpoint);
    })
  );

  onBeforeUnmount(() => {
    window.removeEventListener("resize", updateBreakpoint);
  });
}

return (_ctx: any,_cache: any) => {
  const _component_ionic_element = _resolveComponent("ionic-element")!

  return (_openBlock(), _createBlock(_unref(IonCard), {
    color: 
      __props.selected
        ? 'light'
        : !_unref(local_hovered)
        ? _unref(getIonicColor)(__props.colors?.background)
        : undefined
    ,
    class: _normalizeClass([{
      ..._unref(getBreakpointClasses)(__props.classes?.card, breakpoint.value),
      no_card_border: __props.colors?.borders == undefined,
      background:
        !_unref(local_hovered) &&
        __props.colors?.background != undefined &&
        _unref(getIonicColor)(__props.colors?.background) == undefined,
      hovered: _unref(local_hovered),
    }, "ion-no-padding ion-no-margin"]),
    style: {"width":"100%"},
    button: __props.link != undefined,
    href: __props.link != undefined && _unref(isRequest)(__props.link) && _unref(isGet) ? __props.link.url : undefined,
    onClick: _cache[20] || (_cache[20] = 
      () => {
        if (__props.link != undefined) {
          if (_unref(isEvent)(__props.link)) {
            _unref(store).state.event =
              __props.selected != undefined
                ? {
                    event: 'change_selection',
                    data: {
                      id: __props.id,
                    },
                  }
                : {
                    event: __props.link.event,
                    data: __props.link.data,
                  };
            _ctx.$emit('signal_event');
          } else if (!_unref(isGet)) {
            _unref(store).state.request = {
              url: __props.link.url,
              method: __props.link.method,
            };
            _ctx.$emit('execute_link');
          }
        }
      }
    )
  }, {
    default: _withCtx(() => [
      (title_ref.value != undefined || subtitle_ref.value != undefined)
        ? (_openBlock(), _createBlock(_unref(IonCardHeader), {
            key: 0,
            class: _normalizeClass(["ion-no-padding", _unref(getBreakpointClasses)(__props.classes?.header, breakpoint.value)])
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonGrid), { class: "ion-no-margin" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonRow), { class: "ion-align-items-center" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonCol), { size: "auto" }, {
                        default: _withCtx(() => [
                          (title_ref.value != undefined)
                            ? (_openBlock(), _createBlock(_unref(IonCardTitle), { key: 0 }, {
                                default: _withCtx(() => [
                                  _createElementVNode("b", null, [
                                    _createVNode(_component_ionic_element, {
                                      element: title_ref.value,
                                      "onUpdate:element": _cache[0] || (_cache[0] = ($event: any) => ((title_ref).value = $event)),
                                      onExecute_link: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('execute_link'))),
                                      onSignal_event: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('signal_event')))
                                    }, null, 8, ["element"])
                                  ])
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(IonCol), { size: "auto" }, {
                        default: _withCtx(() => [
                          (subtitle_ref.value != undefined)
                            ? (_openBlock(), _createBlock(_unref(IonCardSubtitle), { key: 0 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ionic_element, {
                                    element: subtitle_ref.value,
                                    "onUpdate:element": _cache[3] || (_cache[3] = ($event: any) => ((subtitle_ref).value = $event)),
                                    onExecute_link: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('execute_link'))),
                                    onSignal_event: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('signal_event')))
                                  }, null, 8, ["element"])
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(IonCol), { size: "1" }),
                      _createVNode(_unref(IonCol), {
                        "size-sm": "auto",
                        size: "12"
                      }, {
                        default: _withCtx(() => [
                          (content_ref.value == undefined && side_element_ref.value != undefined)
                            ? (_openBlock(), _createBlock(_component_ionic_element, {
                                key: 0,
                                element: side_element_ref.value,
                                "onUpdate:element": _cache[6] || (_cache[6] = ($event: any) => ((side_element_ref).value = $event)),
                                onExecute_link: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('execute_link'))),
                                onSignal_event: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('signal_event')))
                              }, null, 8, ["element"]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["class"]))
        : _createCommentVNode("", true),
      (content_ref.value != undefined)
        ? (_openBlock(), _createBlock(_unref(IonCardContent), {
            key: 1,
            class: _normalizeClass(_unref(getBreakpointClasses)(__props.classes?.content, breakpoint.value))
          }, {
            default: _withCtx(() => [
              (side_element_ref.value != undefined)
                ? (_openBlock(), _createBlock(_unref(IonGrid), { key: 0 }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonRow), null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonCol), null, {
                            default: _withCtx(() => [
                              (actual_layout.value == undefined || !_unref(isMatrix)(actual_layout.value))
                                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(actual_layout.value == undefined
                  ? content_ref.value.map((e) => e.id)
                  : actual_layout.value, (element) => {
                                    return (_openBlock(), _createBlock(_component_ionic_element, {
                                      key: 
                  content_ref.value[content_ref.value.findIndex((e) => e.id == element)].id
                ,
                                      element: 
                  content_ref.value[content_ref.value.findIndex((e) => e.id == element)]
                ,
                                      "onUpdate:element": ($event: any) => ((
                  content_ref.value[content_ref.value.findIndex((e) => e.id == element)]
                ) = $event),
                                      onExecute_link: _cache[9] || (_cache[9] = ($event: any) => (_ctx.$emit('execute_link'))),
                                      onSignal_event: _cache[10] || (_cache[10] = ($event: any) => (_ctx.$emit('signal_event')))
                                    }, null, 8, ["element", "onUpdate:element"]))
                                  }), 128))
                                : (_openBlock(), _createBlock(_unref(IonGrid), { key: 1 }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(actual_layout.value, (row, r) => {
                                        return (_openBlock(), _createBlock(_unref(IonRow), {
                                          key: r,
                                          class: "ion-align-items-center"
                                        }, {
                                          default: _withCtx(() => [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(castLayoutRow)(row), (element) => {
                                              return (_openBlock(), _createBlock(_unref(IonCol), {
                                                key: element.id,
                                                "size-xl": _unref(getSize)(element.size, 'xl'),
                                                "size-lg": _unref(getSize)(element.size, 'lg'),
                                                "size-md": _unref(getSize)(element.size, 'md'),
                                                "size-sm": _unref(getSize)(element.size, 'xs'),
                                                size: _unref(getSize)(element.size, 'xs')
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_ionic_element, {
                                                    element: 
                      content_ref.value[
                        content_ref.value.findIndex((e) => e.id == element.id)
                      ]
                    ,
                                                    "onUpdate:element": ($event: any) => ((
                      content_ref.value[
                        content_ref.value.findIndex((e) => e.id == element.id)
                      ]
                    ) = $event),
                                                    onExecute_link: _cache[11] || (_cache[11] = ($event: any) => (_ctx.$emit('execute_link'))),
                                                    onSignal_event: _cache[12] || (_cache[12] = ($event: any) => (_ctx.$emit('signal_event')))
                                                  }, null, 8, ["element", "onUpdate:element"])
                                                ]),
                                                _: 2
                                              }, 1032, ["size-xl", "size-lg", "size-md", "size-sm", "size"]))
                                            }), 128))
                                          ]),
                                          _: 2
                                        }, 1024))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }))
                            ]),
                            _: 1
                          }),
                          _createVNode(_unref(IonCol), {
                            size: "auto",
                            style: {"border-left":"1px solid var(--ion-color-dark)"}
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ionic_element, {
                                element: side_element_ref.value,
                                "onUpdate:element": _cache[13] || (_cache[13] = ($event: any) => ((side_element_ref).value = $event)),
                                onExecute_link: _cache[14] || (_cache[14] = ($event: any) => (_ctx.$emit('execute_link'))),
                                onSignal_event: _cache[15] || (_cache[15] = ($event: any) => (_ctx.$emit('signal_event')))
                              }, null, 8, ["element"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    (actual_layout.value == undefined || !_unref(isMatrix)(actual_layout.value))
                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(actual_layout.value == undefined
              ? content_ref.value.map((e) => e.id)
              : actual_layout.value, (element) => {
                          return (_openBlock(), _createBlock(_component_ionic_element, {
                            key: content_ref.value[content_ref.value.findIndex((e) => e.id == element)].id,
                            element: 
              content_ref.value[content_ref.value.findIndex((e) => e.id == element)]
            ,
                            "onUpdate:element": ($event: any) => ((
              content_ref.value[content_ref.value.findIndex((e) => e.id == element)]
            ) = $event),
                            onExecute_link: _cache[16] || (_cache[16] = ($event: any) => (_ctx.$emit('execute_link'))),
                            onSignal_event: _cache[17] || (_cache[17] = ($event: any) => (_ctx.$emit('signal_event')))
                          }, null, 8, ["element", "onUpdate:element"]))
                        }), 128))
                      : (_openBlock(), _createBlock(_unref(IonGrid), { key: 1 }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(actual_layout.value, (row, r) => {
                              return (_openBlock(), _createBlock(_unref(IonRow), {
                                key: r,
                                class: "ion-align-items-center"
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(castLayoutRow)(row), (element) => {
                                    return (_openBlock(), _createBlock(_unref(IonCol), {
                                      key: element.id,
                                      "size-xl": _unref(getSize)(element.size, 'xl'),
                                      "size-lg": _unref(getSize)(element.size, 'lg'),
                                      "size-md": _unref(getSize)(element.size, 'md'),
                                      "size-sm": _unref(getSize)(element.size, 'xs'),
                                      size: _unref(getSize)(element.size, 'xs')
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_ionic_element, {
                                          element: 
                  content_ref.value[content_ref.value.findIndex((e) => e.id == element.id)]
                ,
                                          "onUpdate:element": ($event: any) => ((
                  content_ref.value[content_ref.value.findIndex((e) => e.id == element.id)]
                ) = $event),
                                          onExecute_link: _cache[18] || (_cache[18] = ($event: any) => (_ctx.$emit('execute_link'))),
                                          onSignal_event: _cache[19] || (_cache[19] = ($event: any) => (_ctx.$emit('signal_event')))
                                        }, null, 8, ["element", "onUpdate:element"])
                                      ]),
                                      _: 2
                                    }, 1032, ["size-xl", "size-lg", "size-md", "size-sm", "size"]))
                                  }), 128))
                                ]),
                                _: 2
                              }, 1024))
                            }), 128))
                          ]),
                          _: 1
                        }))
                  ], 64))
            ]),
            _: 1
          }, 8, ["class"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["color", "class", "button", "href"]))
}
}

})